/* GENERATED from website/volunteer.html — keep in sync (pipeline in project memory) */
(function(){
'use strict';
var rootEl = document.getElementById('omana-volunteer');
if(!rootEl) return;
var root = rootEl;

/* ============================================================
   Content
   ============================================================ */
/* Flip to true to close applications (the Shopify section uses its own theme-editor toggle). */
const APPLICATIONS_CLOSED = false;


/* Section order for the transition dots */
const SECTIONS = ["Contact","Basic Details","Experience","Skills","Festival Week","Email","Tickets","Review"];

/* Availability windows — the "How many shifts" step only shows for the festival window */
const AVAIL = {
  fullBuild:  'Full build-up · 23–30 September',
  shortBuild: 'Short build-up · 27–30 September',
  festival:   'During the festival · 30 September – 6 October',
  breakdown:  'Breakdown · 7–12 October'
};

/* Node list. Each node = one screen.
   kinds: field | trans | sintro | review
   field kinds: text|email|tel|date|textarea|single|multi
   `when` -> function(A) controls visibility (dynamic branching). */
const NODES = [
  // ---- Contact ----
  {id:'nameGroup', sec:'Contact', kind:'field', type:'group', group:'Contact Information', label:'What’s your name?',
    fields:[
      {id:'firstName', type:'text', label:'First name', required:true, placeholder:'First name', autocap:true, half:true},
      {id:'lastName',  type:'text', label:'Last name',  required:true, placeholder:'Last name', autocap:true, half:true}
    ]},
  {id:'email', sec:'Contact', kind:'field', type:'email', label:'What’s your email address?', required:true, placeholder:'your@email.com'},

  // ---- Basic Details ----
  {id:'addrGroup', sec:'Basic Details', kind:'field', type:'group', label:'Where do you live?',
    help:'Your home address.',
    fields:[
      {id:'street',   type:'text', label:'Street & number', required:true, placeholder:'Street and number', autocap:true},
      {id:'postcode', type:'text', label:'Postcode', required:true, placeholder:'Postcode', half:true},
      {id:'city',     type:'text', label:'City', required:true, placeholder:'City', autocap:true, half:true},
      {id:'country',  type:'text', label:'Country', required:true, placeholder:'Country', autocap:true}
    ]},
  {id:'nationality', sec:'Basic Details', kind:'field', type:'text', label:'Nationality', required:true, placeholder:'Your nationality', autocap:true},
  {id:'dob',      sec:'Basic Details', kind:'field', type:'date', label:'Date of birth', required:true,
    min:'1920-01-01', max:'2008-09-30', dateMsg:'Please enter a valid date of birth — volunteers must be 18 by 30 Sep 2026.'},
  {id:'gender',   sec:'Basic Details', kind:'field', type:'single', label:'Gender', required:true,
    options:[{v:'Female'},{v:'Male'},{v:'Non-binary'},{v:'Prefer to self-describe'},{v:'Prefer not to disclose'}]},
  {id:'phone',    sec:'Basic Details', kind:'field', type:'tel', label:'Phone number', required:true, placeholder:'Phone number'},
  {id:'language', sec:'Basic Details', kind:'field', type:'single', label:'Preferred Language of Communication', required:true,
    options:[{v:'Deutsch'},{v:'English'}]},
  {id:'notes',     sec:'Basic Details', kind:'field', type:'textarea', label:'Additional Information or Important Notes', required:false, placeholder:'Optional'},

  // ---- transition ----
  {id:'t1', kind:'trans', secLabel:'Section 2 of 8', title:'Lovely, thank you!', body:"That's your details safely with us — now the part we're most curious about.", upNext:'You & Omana', secIndex:2},

  // ---- Experience & Motivation ----
  {id:'volBefore', sec:'Experience', kind:'field', type:'single', label:'Have you been part of the Omana crew before?', required:true,
    options:[{v:'Yes'},{v:'No'}]},
  {id:'why', sec:'Experience', kind:'field', type:'textarea', label:'What draws you to Omana — why do you want to join the crew?', required:true, placeholder:'In your own words…'},
  {id:'otherFest', sec:'Experience', kind:'field', type:'single', label:'Have you volunteered or worked at other festivals before?', required:true,
    options:[{v:'Yes'},{v:'No'}]},
  {id:'friends', sec:'Experience', kind:'field', type:'single', label:'Are there friends you’d love to be on shift with?', required:true,
    options:[{v:'Yes'},{v:'No'}]},
  {id:'friendNames', sec:'Experience', kind:'field', type:'text', label:'Who are they? (full names)', required:true,
    help:"We can't promise you'll be placed together, but we'll do our best to keep you side by side. Please only apply if you'd also feel good working on your own.",
    placeholder:'Full names, comma-separated', when:A=>A.friends==='Yes'},

  // ---- Skills ----
  {id:'trades', sec:'Skills', kind:'field', type:'multi', label:'Do any of these hands-on skills apply to you?', required:true,
    help:'Optional but hugely helpful for build-up and breakdown — pick anything that fits.',
    options:[
      {v:'Carpentry / Woodworking'},
      {v:'Architecture / Structural Engineering / Construction'},
      {v:'Tailoring / Sewing'},
      {v:'Metalworking / Welding'},
      {v:'Lighting Technology'},
      {v:'Sound Technology'},
      {v:'Engineering'},
      {v:'Experience with forklifts, scissor lifts, cherry pickers, etc.'},
      {v:"Driver's license"},
      {v:'None of the above', exclusive:true}
    ]},

  // ---- Festival Week intro ----
  {id:'fw-intro', kind:'sintro', secIndex:4,
    title:'Festival Week (30.09.–06.10.2026)',
    paras:[
      "Next, a few questions about how you'd like to help and when you can be with us on the bay.",
    ],
    note:"<b>Good to know:</b> the earlier days fill up fast. Being around for the <b>later</b> shifts — the final days and breakdown — genuinely lifts your chances. It means priority placement and a spot that's much easier to hold for you."},

  // ---- Festival Week ----
  {id:'availFrom', sec:'Festival Week', kind:'field', type:'multi', label:'When are you available?', required:true,
    help:'Select all that apply. Build-up and breakdown each cover your full ticket; festival shifts are reimbursed per shift.',
    options:[
      {v:AVAIL.fullBuild, d:'Help set everything up from the ground.'},
      {v:AVAIL.shortBuild, d:'Join the final build-up push.'},
      {v:AVAIL.festival, d:'Be here for the festival itself.'},
      {v:AVAIL.breakdown, d:'Help pack everything down afterwards.'}
    ]},
  {id:'maxShifts', sec:'Festival Week', kind:'field', type:'single', label:'How many shifts would you like to take on at most?', required:true,
    help:'Shifts are worked during the festival. Each is reimbursed within 3 weeks — 1 shift €85 · 2 shifts €170 · 3 shifts €259, capped at your ticket price. More shifts also means a better shot at a spot.',
    when:A=>Array.isArray(A.availFrom)&&A.availFrom.includes(AVAIL.festival),
    options:[{v:'3'},{v:'2'},{v:'1'}]},
  {id:'workAreas', sec:'Festival Week', kind:'field', type:'multi', label:'Which areas feel like your kind of place?', required:true,
    options:[
      {v:'Allrounder', d:"The glue of the festival — rotating between areas, watching entrances, handling waste and ticket control, jumping in wherever hands are needed."},
      {v:'Runner', d:'On your feet and everywhere at once, keeping every team stocked and moving. Tell us more next.'},
      {v:'Awareness', d:'Holding a safe, caring space for everyone on site. For people with awareness experience — tell us more next.'}
    ]},
  {id:'awarenessExp', sec:'Festival Week', kind:'field', type:'textarea', label:'You picked Awareness — do you have awareness experience? Tell us briefly.', required:true,
    placeholder:'A few sentences on your awareness experience — or "none yet, but keen to learn".',
    when:A=>Array.isArray(A.workAreas)&&A.workAreas.includes('Awareness')},
  {id:'awarenessCert', sec:'Festival Week', kind:'field', type:'single', label:'Have you done any awareness workshops or certifications?', required:true,
    options:[{v:'Yes'},{v:'No'}],
    when:A=>Array.isArray(A.workAreas)&&A.workAreas.includes('Awareness')},
  {id:'aboutSelection', sec:'Festival Week', kind:'field', type:'textarea', label:'Tell us a little about the areas you picked — your experience and what you’d bring.', required:true, placeholder:'A few sentences is plenty…',
    when:A=>{ const w=A.workAreas||[]; return !(w.length===1 && w[0]==='Awareness'); }},
  {id:'openOther', sec:'Festival Week', kind:'field', type:'single', label:'If your first choice is already full, are you happy to help somewhere else?', required:true,
    options:[{v:'Yes'},{v:'No'}]},
  {id:'leadRole', sec:'Festival Week', kind:'field', type:'single', label:'Could you imagine taking on a team-lead or senior crew role?', required:true,
    help:'Some of our crew step up to coordinate a team or an area. No pressure — just tell us if it’s something you’d be open to.',
    options:[{v:'Yes, I’d love to'},{v:'Maybe — tell me more'},{v:'Not this time'}]},

  // ---- Email communication (its own confirm question) ----
  {id:'emailConfirm', sec:'Email', kind:'field', type:'single', secLabel:'One quick thing: email', label:'I confirm that emails from volunteers@omana-festival.de will reach my inbox and not land in spam.', required:true,
    help:"We keep in touch mainly by email — it's how you'll hear about your place and your shifts. If our messages slip into spam, you could miss all of it. Not sure how to whitelist us? The confirmation email we send right after you apply walks you through it.",
    row:true, options:[{v:'Yes'},{v:'No'}]},

  // ---- Ticket & Reimbursement ----
  {id:'hasTicket', sec:'Tickets', kind:'field', type:'single', label:'Have you already grabbed a ticket from our shop?', required:true,
    help:"Either way is fine: existing tickets are converted into your Volunteer Ticket once you're accepted; otherwise we'll send you a purchase link.",
    options:[{v:'Yes'},{v:'No'}]},
  {id:'ticketOrder', sec:'Tickets', kind:'field', type:'text', label:"What's your ticket order number?", required:false,
    help:"You'll find it in your order confirmation email (e.g. #1234). Can't find it? Leave this blank — we'll match your ticket via your email address.",
    placeholder:'#1234', when:A=>A.hasTicket==='Yes'},
  {id:'solidarity', sec:'Tickets', kind:'field', type:'single', label:'We keep a few solidarity tickets for people who’d otherwise struggle to afford Omana. Does that apply to you — would you like to apply for one?', required:true,
    help:"Please note: a solidarity ticket is only possible if you work more than one shift during the festival, or join us for the (longer) build-up or breakdown.",
    options:[{v:'Yes'},{v:'No'}]},

  // ---- Review ----
  {id:'review', sec:'Review', kind:'review', secLabel:'Review Your Application', secIndex:7}
];

/* Country codes for phone */
/* Country dial codes [code, flag, name] — alphabetical, type-ahead by name */
const DIALS = [
['+93','🇦🇫','Afghanistan'],['+355','🇦🇱','Albania'],['+213','🇩🇿','Algeria'],['+376','🇦🇩','Andorra'],['+244','🇦🇴','Angola'],['+54','🇦🇷','Argentina'],['+374','🇦🇲','Armenia'],['+61','🇦🇺','Australia'],['+43','🇦🇹','Austria'],['+994','🇦🇿','Azerbaijan'],
['+973','🇧🇭','Bahrain'],['+880','🇧🇩','Bangladesh'],['+375','🇧🇾','Belarus'],['+32','🇧🇪','Belgium'],['+591','🇧🇴','Bolivia'],['+387','🇧🇦','Bosnia & Herzegovina'],['+55','🇧🇷','Brazil'],['+359','🇧🇬','Bulgaria'],
['+855','🇰🇭','Cambodia'],['+237','🇨🇲','Cameroon'],['+1','🇨🇦','Canada'],['+56','🇨🇱','Chile'],['+86','🇨🇳','China'],['+57','🇨🇴','Colombia'],['+506','🇨🇷','Costa Rica'],['+385','🇭🇷','Croatia'],['+53','🇨🇺','Cuba'],['+357','🇨🇾','Cyprus'],['+420','🇨🇿','Czechia'],
['+45','🇩🇰','Denmark'],['+593','🇪🇨','Ecuador'],['+20','🇪🇬','Egypt'],['+372','🇪🇪','Estonia'],['+251','🇪🇹','Ethiopia'],
['+358','🇫🇮','Finland'],['+33','🇫🇷','France'],['+995','🇬🇪','Georgia'],['+49','🇩🇪','Germany'],['+233','🇬🇭','Ghana'],['+30','🇬🇷','Greece'],['+502','🇬🇹','Guatemala'],
['+852','🇭🇰','Hong Kong'],['+36','🇭🇺','Hungary'],['+354','🇮🇸','Iceland'],['+91','🇮🇳','India'],['+62','🇮🇩','Indonesia'],['+98','🇮🇷','Iran'],['+964','🇮🇶','Iraq'],['+353','🇮🇪','Ireland'],['+972','🇮🇱','Israel'],['+39','🇮🇹','Italy'],
['+81','🇯🇵','Japan'],['+962','🇯🇴','Jordan'],['+7','🇰🇿','Kazakhstan'],['+254','🇰🇪','Kenya'],['+965','🇰🇼','Kuwait'],
['+371','🇱🇻','Latvia'],['+961','🇱🇧','Lebanon'],['+218','🇱🇾','Libya'],['+423','🇱🇮','Liechtenstein'],['+370','🇱🇹','Lithuania'],['+352','🇱🇺','Luxembourg'],
['+60','🇲🇾','Malaysia'],['+356','🇲🇹','Malta'],['+52','🇲🇽','Mexico'],['+373','🇲🇩','Moldova'],['+377','🇲🇨','Monaco'],['+976','🇲🇳','Mongolia'],['+382','🇲🇪','Montenegro'],['+212','🇲🇦','Morocco'],
['+977','🇳🇵','Nepal'],['+31','🇳🇱','Netherlands'],['+64','🇳🇿','New Zealand'],['+234','🇳🇬','Nigeria'],['+389','🇲🇰','North Macedonia'],['+47','🇳🇴','Norway'],['+968','🇴🇲','Oman'],
['+92','🇵🇰','Pakistan'],['+970','🇵🇸','Palestine'],['+507','🇵🇦','Panama'],['+595','🇵🇾','Paraguay'],['+51','🇵🇪','Peru'],['+63','🇵🇭','Philippines'],['+48','🇵🇱','Poland'],['+351','🇵🇹','Portugal'],['+974','🇶🇦','Qatar'],
['+40','🇷🇴','Romania'],['+7','🇷🇺','Russia'],['+966','🇸🇦','Saudi Arabia'],['+221','🇸🇳','Senegal'],['+381','🇷🇸','Serbia'],['+65','🇸🇬','Singapore'],['+421','🇸🇰','Slovakia'],['+386','🇸🇮','Slovenia'],['+27','🇿🇦','South Africa'],['+82','🇰🇷','South Korea'],['+34','🇪🇸','Spain'],['+94','🇱🇰','Sri Lanka'],['+46','🇸🇪','Sweden'],['+41','🇨🇭','Switzerland'],
['+886','🇹🇼','Taiwan'],['+255','🇹🇿','Tanzania'],['+66','🇹🇭','Thailand'],['+216','🇹🇳','Tunisia'],['+90','🇹🇷','Turkey'],['+256','🇺🇬','Uganda'],['+380','🇺🇦','Ukraine'],['+971','🇦🇪','United Arab Emirates'],['+44','🇬🇧','United Kingdom'],['+1','🇺🇸','United States'],['+598','🇺🇾','Uruguay'],['+998','🇺🇿','Uzbekistan'],['+58','🇻🇪','Venezuela'],['+84','🇻🇳','Vietnam']
];

/* Review layout: which groups show which fields */
const REVIEW_GROUPS = [
  {g:'Contact', fields:['email','firstName','lastName']},
  {g:'Basic Details', fields:['dob','gender','phone','nationality','street','postcode','city','country','language','notes']},
  {g:'You & Omana', fields:['volBefore','why','otherFest','friends','friendNames']},
  {g:'Skills', fields:['trades']},
  {g:'Festival Week', fields:['availFrom','maxShifts','workAreas','awarenessExp','awarenessCert','aboutSelection','openOther','leadRole']},
  {g:'Email', fields:['emailConfirm']},
  {g:'Ticket & Reimbursement', fields:['hasTicket','ticketOrder','solidarity']}
];

/* ============================================================
   State + engine
   ============================================================ */
const A = {};            // answers
let idx = 0;             // index within the *active* node list
let captchaA=0, captchaB=0;
let confirmChecked=false;

function activeNodes(){ return NODES.filter(n=>!n.when || n.when(A)); }
const ICON_CHECK='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6L9 17l-5-5"/></svg>';


/* ---- flow control ---- */
function startFlow(){
  document.getElementById('ovol-flow').classList.add('on');
  idx=0; render();
}
function closeFlow(){ document.getElementById('ovol-flow').classList.remove('on'); }

function goPrev(){ if(idx>0){ idx--; render(); } }
function goNext(){
  const nodes=activeNodes(), n=nodes[idx];
  if(n.kind==='field' && !validateField(n)) return;
  if(n.kind==='review'){ return submit(); }
  if(idx < nodes.length-1){ idx++; render(); }
}

function validateField(n){
  if(n.type==='group'){
    let ok=true, firstBad=null;
    n.fields.forEach(sf=>{
      if(!sf.required) return;
      const v=A[sf.id];
      const good = sf.type==='email'
        ? (typeof v==='string' && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v.trim()))
        : (v!==undefined && String(v).trim()!=='');
      if(!good){ ok=false; const el=document.getElementById('ovol-fld-'+sf.id); if(el){el.classList.add('bad'); if(!firstBad)firstBad=el;} }
    });
    if(!ok){ const em=document.getElementById('ovol-err'); if(em){em.textContent='Please fill in the required fields.';em.classList.add('show');} if(firstBad)firstBad.focus(); }
    return ok;
  }
  if(n.type==='date'){
    const v=(A[n.id]||'').trim();
    if(!v){ if(n.required){ dateError('This field is required.'); return false; } return true; }
    const bad = isNaN(new Date(v+'T00:00:00').getTime()) || (n.min && v<n.min) || (n.max && v>n.max);
    if(bad){ dateError(n.dateMsg||'Please enter a valid date.'); return false; }
    return true;
  }
  if(!n.required) return true;
  const v=A[n.id];
  let ok;
  if(n.type==='multi') ok = Array.isArray(v)&&v.length>0;
  else if(n.type==='email') ok = typeof v==='string' && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v.trim());
  else ok = v!==undefined && String(v).trim()!=='';
  if(!ok) showFieldError(n);
  return ok;
}
function grpKey(e){ if(e.key!=='Enter')return; e.preventDefault(); const inputs=[...document.querySelectorAll('#ovol-screen .inp')]; const i=inputs.indexOf(e.target); if(i>-1 && i<inputs.length-1) inputs[i+1].focus(); else goNext(); }
function showFieldError(n){
  const em=document.getElementById('ovol-err');
  if(em){ em.textContent = n.type==='email'&&A[n.id] ? 'Please enter a valid email address.' : 'This field is required.'; em.classList.add('show'); }
  root.querySelectorAll('.inp,.ta').forEach(e=>e.classList.add('bad'));
  const opts=document.getElementById('ovol-opts'); if(opts) opts.style.animation='shake .35s';
}
function dateError(msg){
  const em=document.getElementById('ovol-err');
  if(em){ em.textContent=msg; em.classList.add('show'); }
  root.querySelectorAll('.inp').forEach(e=>e.classList.add('bad'));
}

/* section label + progress */
function sectionMeta(nodes,i){
  const n=nodes[i];
  if(n.secLabel) return n.secLabel;
  if(n.kind==='field'){
    const same=nodes.filter(x=>x.kind==='field'&&x.sec===n.sec);
    const pos=same.indexOf(n)+1;
    return `${secName(n.sec)} — Question ${pos} of ${same.length}`;
  }
  return '';
}
function secName(s){ return ({'Contact':'Contact Details','Experience':'You & Omana','Skills':'Skills & Trades','Tickets':'Ticket & Reimbursement'})[s] || s; }

function render(){
  const nodes=activeNodes();
  if(idx>nodes.length-1) idx=nodes.length-1;
  const n=nodes[idx];
  const total=nodes.length, cur=idx+1;

  document.getElementById('ovol-pbar').style.width = Math.round(cur/total*100)+'%';
  document.getElementById('ovol-pcount').textContent = `${cur} / ${total}`;
  document.getElementById('ovol-ppct').textContent = Math.round(cur/total*100)+'%';
  document.getElementById('ovol-psection').textContent = sectionMeta(nodes,idx);
  document.getElementById('ovol-prev').disabled = idx===0;
  root.querySelector('.f-close').style.display = idx===0 ? 'flex':'none';

  const nextBtn=document.getElementById('ovol-next');
  const scroll=root.querySelector('.f-scroll');
  scroll.classList.toggle('align-top', n.kind==='trans'||n.kind==='sintro'||n.kind==='review');

  let html='';
  if(n.kind==='trans')      html=renderTrans(n);
  else if(n.kind==='sintro')html=renderSintro(n);
  else if(n.kind==='review')html=renderReview();
  else                      html=renderField(n);
  document.getElementById('ovol-screen').innerHTML=html;

  // next-button label
  if(n.kind==='trans'||n.kind==='sintro') nextBtn.innerHTML='Continue <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M9 6l6 6-6 6"/></svg>';
  else if(n.kind==='review') nextBtn.innerHTML='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 2L11 13M22 2l-7 20-4-9-9-4 20-7z"/></svg> Submit';
  else nextBtn.innerHTML='OK <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M9 6l6 6-6 6"/></svg>';

  root.querySelector('.f-body').scrollTop=0;
  // autofocus text inputs
  const f=root.querySelector('.inp,.ta'); if(f && (n.type==='text'||n.type==='email'||n.type==='textarea'||n.type==='tel'||n.type==='group')) setTimeout(()=>f.focus(),80);
}


function renderField(n){
  let inner='';
  const req = n.required ? '<span class="req">*</span>':'';
  const group = n.group ? `<div class="q-group">${n.group}</div>`:'';
  const help = n.help ? `<div class="q-help">${n.help}</div>`:'';

  if(n.type==='group'){
    inner = `<div class="grid">`+ n.fields.map(sf=>{
      const r = sf.required ? '<span class="req">*</span>':'';
      const cap = sf.autocap ? 'autocapitalize="words"':'autocapitalize="off"';
      const t = sf.type==='email'?'email':'text';
      return `<div class="gf ${sf.half?'half':''}">
        <label class="gf-l" for="ovol-fld-${sf.id}">${sf.label} ${r}</label>
        <input class="inp" id="ovol-fld-${sf.id}" type="${t}" ${cap} autocomplete="${autoc(sf.id)}" placeholder="${sf.placeholder||''}" value="${escAttr(A[sf.id]||'')}" oninput="OVOL.setVal('${sf.id}',this.value)" onkeydown="OVOL.grpKey(event)">
      </div>`;
    }).join('')+`</div>`;
  } else if(n.type==='single'||n.type==='multi'){
    const sel=A[n.id];
    const rowCls = n.row ? ' row':'';
    inner = `<div class="opts${rowCls}" id="ovol-opts">`+ n.options.map((o,i)=>{
      const on = n.type==='multi' ? (Array.isArray(sel)&&sel.includes(o.v)) : sel===o.v;
      const dd = o.d ? `<div class="od">${o.d}</div>`:'';
      const chk = n.type==='multi' ? `<span class="chk">${ICON_CHECK}</span>`:'';
      return `<button type="button" class="opt ${n.type==='multi'?'multi':''} ${on?'on':''}" onclick="OVOL.pick('${n.id}','${n.type}',${i})">${chk}<div class="ot">${o.v}</div>${dd}</button>`;
    }).join('')+`</div>`;
  } else if(n.type==='textarea'){
    inner = `<textarea class="ta" id="ovol-fld" placeholder="${n.placeholder||''}" oninput="OVOL.setVal('${n.id}',this.value)">${A[n.id]||''}</textarea>`;
  } else if(n.type==='tel'){
    const cur=A[n.id]||{code:'+49',num:''};
    inner = `<div class="telrow">
      <select id="ovol-dial" onchange="OVOL.setTel('${n.id}')">${DIALS.map(d=>`<option value="${d[0]}" ${cur.code===d[0]?'selected':''}>${d[2]} ${d[1]} ${d[0]}</option>`).join('')}</select>
      <input class="inp" id="ovol-fld" type="tel" inputmode="tel" placeholder="${n.placeholder||''}" value="${cur.num||''}" oninput="OVOL.setTel('${n.id}')">
    </div>`;
  } else if(n.type==='date'){
    inner = `<input class="inp" id="ovol-fld" type="date" min="${n.min||''}" max="${n.max||''}" value="${A[n.id]||''}" onchange="OVOL.setVal('${n.id}',this.value)">`;
  } else {
    const t = n.type==='email'?'email':'text';
    const cap = n.autocap ? 'autocapitalize="words"':'autocapitalize="off"';
    inner = `<input class="inp" id="ovol-fld" type="${t}" ${cap} autocomplete="${autoc(n.id)}" placeholder="${n.placeholder||''}" value="${escAttr(A[n.id]||'')}" oninput="OVOL.setVal('${n.id}',this.value)" onkeydown="if(event.key==='Enter'){event.preventDefault();OVOL.goNext();}">`;
  }

  const isInput = !(n.type==='single'||n.type==='multi');
  const errAnchor = `<div class="err-msg" id="ovol-err">This field is required.</div>`;
  return `${group}
    <div class="q-label">${n.label} ${req}</div>
    ${help}
    <div class="field" style="${isInput?'':'margin-top:14px'}">${inner}</div>
    ${errAnchor}`;
}
function autoc(id){ return ({email:'email',postcode:'postal-code',city:'address-level2',street:'street-address',country:'country-name'})[id]||'off'; }
function escAttr(s){ return String(s).replace(/"/g,'&quot;'); }

function renderTrans(n){
  const dots = SECTIONS.map((s,i)=>{
    let c=''; if(i<n.secIndex) c='ovol-done'; else if(i===n.secIndex) c='cur';
    return `<i class="${c}"></i>`;
  }).join('');
  return `<div class="trans screen">
    <div class="ring">${ICON_CHECK}</div>
    <h2>${n.title}</h2>
    <p>${n.body}</p>
    <div class="dots">${dots}</div>
    <div class="next">Up next: <b>${n.upNext}</b></div>
  </div>`;
}
function renderSintro(n){
  return `<div class="sintro screen">
    <h2>${n.title}</h2>
    ${n.paras.map(p=>`<p>${p}</p>`).join('')}
    ${n.note?`<div class="note">${n.note}</div>`:''}
  </div>`;
}

/* ---- input handlers ---- */
function setVal(id,v){ A[id]=v; clearErr(); }
function setTel(id){
  const code=document.getElementById('ovol-dial').value, num=document.getElementById('ovol-fld').value;
  A[id]={code,num}; clearErr();
}
function pick(id,type,i){
  const o=nodeById(id).options[i];
  if(type==='single'){ A[id]=o.v; render(); }   // selection only — user presses OK to advance
  else{
    let arr=Array.isArray(A[id])?A[id].slice():[];
    if(o.exclusive){ arr = arr.includes(o.v)?[]:[o.v]; }
    else{
      arr = arr.filter(x=>{ const ex=nodeById(id).options.find(op=>op.v===x); return !(ex&&ex.exclusive); }); // drop exclusive if picking normal
      if(arr.includes(o.v)) arr=arr.filter(x=>x!==o.v); else arr.push(o.v);
    }
    A[id]=arr; render();
  }
  clearErr();
}
function clearErr(){ const em=document.getElementById('ovol-err'); if(em) em.classList.remove('show'); root.querySelectorAll('.inp,.ta').forEach(e=>e.classList.remove('bad')); }
function nodeById(id){ return NODES.find(n=>n.id===id); }
/* resolves top-level fields AND grouped sub-fields (for the review) */
function fieldById(id){
  for(const n of NODES){
    if(n.id===id) return {label:n.label, when:n.when};
    if(n.type==='group'&&n.fields){ const sf=n.fields.find(f=>f.id===id); if(sf) return {label:sf.label, when:n.when}; }
  }
  return null;
}

/* ---- review ---- */
function fmtAnswer(id){
  const v=A[id];
  if(v===undefined||v===''||(Array.isArray(v)&&v.length===0)) return {empty:true};
  if(Array.isArray(v)) return {chips:v};
  if(typeof v==='object'&&v.code!==undefined) return {text:(v.code+' '+v.num).trim()};
  return {text:String(v)};
}
function renderReview(){
  const groups=REVIEW_GROUPS.map(G=>{
    const rows=G.fields.filter(fid=>{ const f=fieldById(fid); return f && (!f.when||f.when(A)); }).map(fid=>{
      const f=fieldById(fid), ans=fmtAnswer(fid);
      let a;
      if(ans.empty) a=`<div class="ra empty">—</div>`;
      else if(ans.chips) a=`<div class="chips">${ans.chips.map(c=>`<span class="chip">${c}</span>`).join('')}</div>`;
      else a=`<div class="ra">${ans.text}</div>`;
      return `<div class="rrow"><div class="rq">${f.label}</div>${a}</div>`;
    }).join('');
    return rows ? `<div class="rcard"><div class="rg">${G.g}</div>${rows}</div>`:'';
  }).join('');

  return `<div class="review screen">
    <div class="r-top">
      <h2>Review Your Application</h2>
      <button class="edit" onclick="OVOL.editAll()"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 20h9M16.5 3.5a2.1 2.1 0 013 3L7 19l-4 1 1-4 12.5-12.5z"/></svg> Edit</button>
    </div>
    <div class="rsub">Please review your answers before submitting.</div>
    ${groups}
    <div class="confirm ${confirmChecked?'on':''}" id="ovol-confirm" onclick="OVOL.toggleConfirm()">
      <span class="box">${ICON_CHECK}</span>
      <span>I confirm that the information I have provided is correct and that I am available during the stated time periods.</span>
    </div>
    <div class="captcha">
      <div class="ch"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><path d="M9 12l2 2 4-4"/></svg> Security Verification</div>
      <div class="cp">Please solve this math problem to continue:</div>
      <div class="crow">
        <span class="sum">${captchaA} + ${captchaB} =</span>
        <input class="cin" id="ovol-captcha" type="number" inputmode="numeric" placeholder="?" oninput="OVOL.clearCaptchaErr()">
        <button class="refresh" onclick="OVOL.newCaptcha()" aria-label="New problem"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M23 4v6h-6M1 20v-6h6"/><path d="M3.5 9a9 9 0 0114.9-3.4L23 10M1 14l4.6 4.4A9 9 0 0020.5 15"/></svg></button>
      </div>
    </div>
    <div class="priv">For information on how we process your data, please see our <a href="#">Privacy Policy</a>.</div>
  </div>`;
}
function toggleConfirm(){ confirmChecked=!confirmChecked; document.getElementById('ovol-confirm').classList.toggle('on',confirmChecked); document.getElementById('ovol-confirm').classList.remove('bad'); }
function newCaptcha(){ captchaA=Math.floor(Math.random()*8)+2; captchaB=Math.floor(Math.random()*8)+2; if(root.querySelector('.review')) render(); }
function clearCaptchaErr(){ const c=document.getElementById('ovol-captcha'); if(c)c.classList.remove('bad'); }

/* ---- integrations ----
   Config is injected by the Shopify section via window.OVOL_CFG (Google Sheet
   Apps Script URL + Klaviyo public key/list). Empty locally → sends are skipped. */
const OVOL_CFG = (typeof window!=='undefined' && window.OVOL_CFG) || {};

/* Flatten answers into one clean, sheet/CRM-friendly record */
function buildPayload(){
  return {
    submittedAt: new Date().toISOString(),
    firstName:A.firstName||'', lastName:A.lastName||'', email:A.email||'',
    phone: A.phone ? ((A.phone.code||'')+' '+(A.phone.num||'')).trim() : '',
    street:A.street||'', postcode:A.postcode||'', city:A.city||'', country:A.country||'',
    nationality:A.nationality||'', dob:A.dob||'', gender:A.gender||'', language:A.language||'',
    notes:A.notes||'',
    volunteeredBefore:A.volBefore||'', motivation:A.why||'', otherFestivals:A.otherFest||'',
    friends:A.friends||'', friendNames:A.friendNames||'',
    trades:(A.trades||[]).join('; '),
    availableFrom:A.availFrom||'', maxShifts:A.maxShifts||'',
    workAreas:(A.workAreas||[]).join('; '),
    awarenessExp:A.awarenessExp||'', awarenessCert:A.awarenessCert||'',
    aboutSelection:A.aboutSelection||'',
    openToOtherAreas:A.openOther||'', leadRole:A.leadRole||'', emailConfirmed:A.emailConfirm||'',
    hasTicket:A.hasTicket||'', ticketOrder:A.ticketOrder||'', solidarity:A.solidarity||''
  };
}
/* Google Sheet via an Apps Script Web App (fire-and-forget; no-cors) */
function sendToSheet(p){
  if(!OVOL_CFG.sheetUrl) return;
  try{ fetch(OVOL_CFG.sheetUrl,{method:'POST',mode:'no-cors',
    headers:{'Content-Type':'text/plain;charset=utf-8'}, body:JSON.stringify(p)}); }catch(e){}
}
/* Klaviyo client-side subscribe → a "Subscribed to List" Flow sends the confirmation */
function sendToKlaviyo(p){
  if(!OVOL_CFG.klaviyoCompany || !OVOL_CFG.klaviyoList) return Promise.resolve(false);
  return fetch('https://a.klaviyo.com/client/subscriptions/?company_id='+encodeURIComponent(OVOL_CFG.klaviyoCompany),{
    method:'POST', headers:{'content-type':'application/json','revision':'2024-10-15'},
    body:JSON.stringify({data:{
      type:'subscription',
      attributes:{profile:{data:{type:'profile',attributes:{
        email:p.email, first_name:p.firstName, last_name:p.lastName,
        properties:{ volunteer_areas:p.workAreas, volunteer_available_from:p.availableFrom,
          volunteer_has_ticket:p.hasTicket, volunteer_max_shifts:p.maxShifts, source:'volunteer-application' }
      }}}},
      relationships:{list:{data:{type:'list',id:OVOL_CFG.klaviyoList}}}
    }})
  }).then(function(r){ if(r.status!==202 && !r.ok) throw new Error('klaviyo '+r.status); return true; });
}

function submit(){
  let ok=true;
  if(!confirmChecked){ document.getElementById('ovol-confirm').classList.add('bad'); ok=false; }
  const ci=document.getElementById('ovol-captcha');
  if(!ci || parseInt(ci.value,10)!==captchaA+captchaB){ if(ci)ci.classList.add('bad'); ok=false; }
  if(!ok){ root.querySelector('.f-body').scrollTop=root.querySelector('.f-body').scrollHeight; return; }

  const payload=buildPayload();
  sendToSheet(payload);                                          // → Google Sheet row
  sendToKlaviyo(payload).catch(function(e){ console.warn('Klaviyo subscribe failed:', e); }); // → confirmation email
  console.log('Volunteer application payload:', payload);
  document.getElementById('ovol-doneName').textContent = A.firstName || 'friend';
  document.getElementById('ovol-done').classList.add('on');
  closeFlow();
}

/* init */
newCaptcha();

root.querySelectorAll('.faq-q').forEach(function(btn){
  btn.addEventListener('click', function(){
    var item = btn.closest('.faq-item'), a = item.querySelector('.faq-a');
    var open = item.classList.toggle('open');
    a.style.maxHeight = open ? a.querySelector('.inner').scrollHeight + 'px' : '0';
  });
});

window.OVOL = {
  startFlow: startFlow, closeFlow: closeFlow, goPrev: goPrev, goNext: goNext,
  pick: pick, setVal: setVal, setTel: setTel, grpKey: grpKey,
  toggleConfirm: toggleConfirm, newCaptcha: newCaptcha, clearCaptchaErr: clearCaptchaErr,
  editAll: function(){ idx = 0; render(); }
};
})();
